





















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class TinggiBadan extends Vue {
  @Prop() setTb: string;
  @Prop() setLabel!: string;
  // tb = null;
  label = "";
  placeholder = this.setLabel;
  msg = "";
  validasi = [(v) => this.cek(v) || this.message()];
  // @Watch("tb")
  // changeTb(v) {
  //   if (this.setLabel == "") {
  //     this.label = "";
  //     this.placeholder = "";
  //   } else {
  //     if (v == "" || v == null) {
  //       this.label = "";
  //       this.placeholder = this.setLabel;
  //     } else {
  //       this.label = this.setLabel;
  //       this.placeholder = "";
  //     }
  //   }
  //   this.$emit("tb", v);
  // }
  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setTb == "" || this.setTb == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }
  @Watch("setTb")
  changesetTb(v) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (v == "" || v == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("tb", v);
    this.setTb = v;
  }
  titik() {
    if (this.setTb) {
      this.setTb = this.setTb.split(",").join(".");
    }
  }
  cek(v) {
    if (this.setTb != null) {
      if (
        this.setTb.substring(this.setTb.length - 1, this.setTb.length) == ","
      ) {
        this.titik();
      } else if (isNaN(Number(this.setTb)))
        this.setTb = this.setTb.substring(0, this.setTb.length - 1);
      if (this.setTb.length > 6)
        this.setTb = this.setTb.substring(0, this.setTb.length - 1);
    }

    if (v == "" || v == null) {
      this.msg = "*Kolom Tinggi Badan harus diisi";
      return false;
    } else if (Number(v) > 999) {
      this.msg = "*Tinggi Badan " + v + " cm, Anda yakin?";
      return false;
    } else return true;
  }

  message() {
    return this.msg;
  }
}
